// Headless export registration for Correlation Finder (`cf`). CorrelationFinderChart
// renders through the Highcharts ChartContainer (Phase 2 hook covers it). groupType and
// axisType are required view-selections the driver must supply.
// Spec: .aidev/tasks/headless-charts-sdk-spike/docs/tasks/03-highcharts-rollout.md §4.2

import { commonHcProps, registerHc } from '@aytm/app/stats/page/question-views/components/charts/lib/hc-exportable'

import CorrelationFinderChart from '@aytm/app/stats/page/question-views/cq/components/partial/Chart'

registerHc(['cf'], CorrelationFinderChart, (data: any, params: any) => ({
  ...commonHcProps(data, params),
  // view-selection → params (groupType & axisType are required)
  groupType: params.groupType,
  axisType: params.axisType,
  ignoreAmount: params.ignoreAmount,
  ignorePercents: params.ignorePercents,
  confidenceLevel: params.confidenceLevel,
  significanceLevel: params.significanceLevel,
  confidenceLevels: params.confidenceLevels,
  percentDecimals: params.percentDecimals,
  // question data → data
  answerType: data.answerType
}))
